import './Avatar.css'

const Avatar = () => {
    return <div className="CB">CB</div>;
  };
  
  export default Avatar;
  